import request from '../../utils/request';
export default {
    // 查询项目省份下患者数量
    getProjectCenterList: params => {
        return request.post(`/cplat-dev/externalHanging/getProjectCenterList`, params)
    },
    // 查询项目下的中心患者数量
    getCenterPatientSize:params => {
        return request.post(`/cplat-dev/externalHanging/getCenterPatientSize`, params)
    },
    // 查询病例相关统计
    getCaseStatistics: params => {
        return request.post(`/cplat-dev/externalHanging/getCaseStatistics`, params)
    },
}